<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <el-form class="toolbar" :inline="true" size="mini">
      <el-form-item label="关键字">
        <el-input v-model="params.keyword" placeholder="请输入关键字" clearable></el-input>
      </el-form-item>
      <el-form-item label="开始时间">
        <el-date-picker
          v-model="params.d1"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择开始时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间">
        <el-date-picker
          v-model="params.d2"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择结束时间">
        </el-date-picker>
      </el-form-item>

      <el-button type="primary" @click="listSearch" size="mini">查询</el-button>
      <el-button type="success" @click="addCompany" size="mini">新增</el-button>
    </el-form>
    <paging :url="url.list" :params="params" ref="paging" style="width: 990px;">
      <el-table border slot-scope="grid" :data="grid.data" style="width: 100%;" height="500px" v-loading="grid.loading || loading">
        <el-table-column align="center" prop="F_IDNo" label="身份证号" width="160">
          <template slot-scope="scope">
            <el-button @click="onEdit(scope.row,false)" type="text" size="small">{{scope.row.F_IDNo}}</el-button>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="F_Name" label="姓名" width="120"></el-table-column>
        <!--<el-table-column align="center" prop="F_DrivingLicenseNo" label="驾驶证编号" width="120"></el-table-column>-->
        <!--<el-table-column align="center" prop="F_DriveCardTime" label="驾驶证有效期" width="100"></el-table-column>-->
        <el-table-column align="center" prop="F_CYZGNo" label="从业资格证编号" width="130">
          <!--<template slot-scope="scope">-->
          <!--<el-tag v-if="scope.row.F_EmissionStandard == 3" type="success">国Ⅲ</el-tag>-->
          <!--<el-tag v-if="scope.row.F_EmissionStandard == 4" type="danger">国Ⅳ</el-tag>-->
          <!--<el-tag v-if="scope.row.F_EmissionStandard == 5" type="info">国Ⅴ</el-tag>-->
          <!--<el-tag v-if="scope.row.F_EmissionStandard == 6" type="warning">国Ⅵ</el-tag>-->
          <!--</template>-->
        </el-table-column>
        <el-table-column align="center" prop="F_MountGuardTime" label="从业资格证有效期" width="160"></el-table-column>
        <el-table-column align="center" prop="F_Tel" label="联系方式" width="130"></el-table-column>
        <el-table-column fixed="right" label="操作" width="220" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button @click="onEdit(scope.row,true)" type="text" size="small">编辑</el-button>
            <el-button @click="onDelete(scope.row)" type="text" size="small">删除</el-button>
            <el-button @click="onPhone(scope.row)" type="text" size="small">关联手机号</el-button>
          </template>
        </el-table-column>
      </el-table>
    </paging>

    <!--修改弹框-->
    <dialog-form title="押运员"
                 :formTemplate="formTemplate"
                 :visible.sync="visible"
                 :form="form" :rules="rules"
                 :url="url.save"
                 :isEdit="isEdit"
                 :canEdit="canEdit"
                 :labelPosition="labelPosition"
                 :labelWidth="labelWidth"
                 @beforeSave="beforeSave"
                 @saved="editSave()">
    </dialog-form>

    <el-dialog :close-on-click-modal="false" center title="关联手机号" :visible.sync="dialogTablePhone">
      <el-button @click="" type="text" size="small"></el-button>
      <el-table :data="Phones" border>
        <el-table-column header-align="center" align="center" property="F_TelNo" label="手机号"></el-table-column>
        <el-table-column header-align="center" align="center" property="F_CreateTime" label="创建时间"></el-table-column>
        <el-table-column header-align="center" align="center" property="F_Creator" label="操作人"></el-table-column>
        <el-table-column fixed="right" label="操作" width="100" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button @click="onDeletePhone(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="addPhone">新增关联手机号</el-button>
        <el-button type="primary" @click="dialogTablePhone = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
  import Paging from '@/components/Table/Paging'
  import DialogForm from '@/components/Dialogs/DialogForm';

  export default {
    components: {
      Paging, DialogForm
    },
    props: {
      screen: {
        type: Object,
        default: () => {
        }
      },
    },
    data() {
      let validateCarNo = (rule, value, callback) => {
        let regex = /(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领台A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$)/;
        if (value != null && !regex.test(value)) {
          callback(new Error('请输入正确的车牌号'));
        } else {
          callback();
        }
      }
      return {
        labelWidth:'160px',
        labelPosition:'right',
        url: {
          list: SZH.assets.api + '/WHPSuperCargo/GetGridJson',
          save: SZH.assets.api + '/WHPSuperCargo/SumbitForm',
          delete: SZH.assets.api + '/WHPSuperCargo/DeleteForm',
          get: SZH.assets.api + '/WHPSuperCargo/GetFormJson',
          GetGridJsonLinkUser: SZH.assets.api + '/WHPDriver/GetGridJsonLinkUser',
          InsertLinkTelUser: SZH.assets.api + '/WHPDriver/InsertLinkTelUser',
          DeleteLinkTelUser: SZH.assets.api + '/WHPDriver/DeleteLinkTelUser',
          companySelect: SZH.assets.api + '/WHPTransCompany/GetAllJson',
        },
        loading: false,
        fullscreenLoading: false,
        params: {
          keyword:'',
          d1:'',
          d2:''
        },
        visible: false,
        form: {
          F_Id: '',
          F_IDNo: '',
          F_Name: '',//姓名
          F_CYZGNo: '',//从业资格证编号
          F_MountGuardTime: '',//从业资格证有效期
          F_Tel: '',//联系方式


          F_IDImgUrl:'',//身份证图片
          F_ImgUrl:'',//从业资格证图片

          F_IDImgUrlBefore:[],
          F_ImgUrlBefore:[],
          F_DriverImgBase64:'',
          F_IDImgBase64:'',
          F_ImgBase64:''

        },
        isEdit:false,
        formTemplate: [
          {col: 24, label: '身份证号', prop: 'F_IDNo'},
          {col: 12, label: '姓名', prop: 'F_Name'},
          {col: 12, label: '从业资格证编号', prop: 'F_CYZGNo'},
          {col: 12, label: '从业资格证有效期', prop: 'F_MountGuardTime',type: "date"},
          {col: 12, label: '联系方式', prop: 'F_Tel'},
          {col: 12, label: '身份证图片', prop: 'F_IDImgUrlBefore',type: "pictureBase",default: [],formIdProp: "Id",pictureType: "WHPimg",limit: 1,},
          {col: 12, label: '从业资格证图片', prop: 'F_ImgUrlBefore',type: "pictureBase",default: [],formIdProp: "Id",pictureType: "WHPimg",limit: 1,},
        ],
        rules: {
          F_IDNo: [
            {required: true, message: '请输入身份证号', trigger: 'blur'},
          ],
          F_Name: [
            {required: true, message: '请输入姓名', trigger: 'blur'},
          ],
          F_DrivingLicenseNo: [
            {required: true, message: '请输入驾驶证编号', trigger: 'blur'},
          ],
          F_DriveCardTime: [
            {required: true, message: '请选择驾驶证有效期', trigger: 'change'},
          ],
          F_CYZGNo: [
            {required: true, message: '请输入从业资格证编号', trigger: 'blur'},
          ],
          F_MountGuardTime: [
            {required: true, message: '请选择从业资格证有效期', trigger: 'change'},
          ],
          F_Tel: [
            {required: true, message: '请输入联系方式', trigger: 'blur'},
          ],

          F_DriverImgUrlBefore: [
            {required: true, message: '请选择驾驶证图片', trigger: 'blur'},
          ],
          F_IDImgUrlBefore: [
            {required: true, message: '请选择身份证图片', trigger: 'blur'},
          ],
          F_ImgUrlBefore: [
            {required: true, message: '请选择从业资格证图片', trigger: 'blur'},
          ],

        },
        canEdit:false,
        dialogTablePhone:false,
        Phones:[],
        row:'',
      }
    },
    methods: {

      onPhone(row){
        let self = this;
        self.dialogTablePhone = true;
        self.getPhones(row);
      },
      getPhones(row){
        let self = this;
        self.row = row;
        self.fullscreenLoading = true;
        self.$http.post(self.url.GetGridJsonLinkUser, {
          Data:{
            keyValue: row.F_Id
          },
          PageIndex:1,
          PageSize:200
        }).then(result => {
          if (result.state == true) {
            self.Phones = result.data.Data
          } else {
            self.Phones = [];
            self.$message.error(result.message);
          }
          self.fullscreenLoading = false;
        }, () => {
          self.fullscreenLoading = false;
          self.$message.error('数据作废失败，请检查您的网络是否可用。');
        });
      },
      addPhone(){
        let self = this;
        self.$prompt('请输入手机号', '新增手机号', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^((13|14|15|17|18|19|16|11|12)[0-9]{9})?$/,
          inputErrorMessage: '手机号格式不正确',
          closeOnClickModal:false,
          center: true
        }).then(({ value }) => {
          self.fullscreenLoading = true;
          self.$http.post(self.url.InsertLinkTelUser, {
            F_TelNo:value,
            F_Type:2,
            F_ObjectId:self.row.F_Id
          }).then(result => {
            if (result.state == true) {
              self.$message.success('操作成功');
              self.getPhones(self.row);
            } else {
              self.$message.error(result.message);
            }
            self.fullscreenLoading = false;
          }, () => {
            self.fullscreenLoading = false;
            self.$message.error('数据作废失败，请检查您的网络是否可用。');
          });
        }).catch(() => {

        });
      },
      onDeletePhone(row){
        var self = this;
        self.$confirm(`将手机号${row.F_TelNo}删除, 是否继续?`, '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          self.fullscreenLoading = true;
          self.$http.post(self.url.DeleteLinkTelUser, {
            keyValue: row.F_Id
          }).then(result => {
            if (result.state == true) {
              self.$message.success('删除成功!');
              self.getPhones(self.row);
            } else {
              self.$message.error(result.message);
            }
            self.fullscreenLoading = false;
          }, () => {
            self.fullscreenLoading = false;
            self.$message.error('数据作废失败，请检查您的网络是否可用。');
          });
        }).catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },
      addCompany(){
        let self = this;
        self.visible = true;
        self.canEdit = true;
        self.form.F_DriverImgUrlBefore = [];
        self.form.F_IDImgUrlBefore = [];
        self.form.F_ImgUrlBefore = [];

      },
      listSearch() {
        this.$refs['paging'].reload();
      },
      beforeSave(){
        let self = this;

        self.form.F_IDImgUrl = self.form.F_IDImgUrlBefore[0].path;
        self.form.F_ImgUrl = self.form.F_ImgUrlBefore[0].path;
      },
      // 保存
      editSave() {
        this.$message.success('保存成功');
        this.$refs['paging'].reload();
      },
      onEdit(row,flag){
        let self = this;
        const loading = self.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        self.visible = true;
        self.form.F_IDImgUrlBefore = [];
        self.form.F_ImgUrlBefore = [];
        self.canEdit = flag;
        self.$http.post(self.url.get, {
          keyValue: row.F_Id
        }).then(result => {
          if (result.state == true) {
            self.$nextTick(()=>{
              for(let i in self.form){
                for(let k in result.data){
                  if(i == k){
                    self.form[i] = result.data[k];
                  }
                }
                if(i == 'F_IDImgBase64'){
                  let obj = {
                    path:result.data.F_IDImgUrl,
                    Url:result.data.F_IDImgBase64
                  };
                  self.form.F_IDImgUrlBefore.push(obj);
                }
                if(i == 'F_ImgBase64'){
                  let obj = {
                    path:result.data.F_ImgUrl,
                    Url:result.data.F_ImgBase64
                  };
                  self.form.F_ImgUrlBefore.push(obj);
                }

              }
            });
          } else {

          }
          loading.close();
        }, () => {
          loading.close();
          self.$message.error('数据作废失败，请检查您的网络是否可用。');
        });
      },

      onDelete(row) {
        var self = this;
        self.$confirm(`将${row.F_Name}删除, 是否继续?`, '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          self.fullscreenLoading = true;
          self.$http.post(self.url.delete, {
            keyValue: row.F_Id
          }).then(result => {
            if (result.state == true) {
              self.$refs['paging'].loadData();
            } else {
              self.$message.error(result.message);
            }
            self.fullscreenLoading = false;
          }, () => {
            self.fullscreenLoading = false;
            self.$message.error('数据作废失败，请检查您的网络是否可用。');
          });
        }).catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },
    },
    computed: {},
    created() {
    },
    mounted() {
    },
    watch: {}

  }
</script>

<style type="text/css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Me/HazardousChemicalsEntry/Escort/Escort.vue